import { render, staticRenderFns } from "./SecondaryChildNavItem.vue?vue&type=template&id=5ea0711e&"
import script from "./SecondaryChildNavItem.vue?vue&type=script&lang=js&"
export * from "./SecondaryChildNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports